import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { Box,useMediaQuery } from "@mui/material";
import RegisterMain from "../components/RegisterMain";
import axios from "axios";
import { Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useParams } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_REST_URL;



const Emailpage = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");


 
  const { token } = useParams();
  console.log("propswa",token);

  const [successMessage, setSuccessMessage] = useState('');
  // const { token } = useParams();
  const getData = async () => {
    const res = await axios.get(`${apiUrl}/CCE/api/v1/userEngine/email_verify/${token}`);
    console.log("reswa",res);
    // const id=res.data.response.userDetail.verification_link

    if(res.data.response.emailVerified===true){
      setSuccessMessage('Verification Successful!');
    }else{
      setSuccessMessage('Verification Failed!');
    }
  }
  // console.log("tokenwa",token);
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
    {isSmallScreen ?(<span><Navbar />
      <RegisterMain />
      <Box sx={styles.formboxres}>
      {successMessage && (
          <div
            style={{
              color: "green",
              textAlign: "center",
              margin: "0px 0px 18px 0px",
              fontSize: "22px",
            }}
          >
            {successMessage}
          </div>
        )}
        <Typography sx={{ textAlign: "left" }}>
          “Congratulations!" Your email address has been successfully verified,
          and your account is now fully activated. Thank you for taking the time
          to complete this step.
        </Typography>
        <Typography sx={{ textAlign: "left", marginTop: "15px" }}>
          Now that your email address is verified, you can{" "}
          <RouterLink
            to="/signin"
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            click here to log in
          </RouterLink>{" "}
          and enjoy the full benefits of our services.
        </Typography>
        <Typography sx={{ textAlign: "left", marginTop: "15px" }}>
          If you have any questions or encounter any issues, please don't
          hesitate to reach out to our support team at{" "}
          <a href="mailto:guest@investek.in" style={styles.emailLink}>
            guest@investek.in
          </a>
          .”
        </Typography>

       
      </Box>

      <Footer /></span>):(<span><Navbar />
      <RegisterMain />
      <Box sx={styles.formbox}>
      {successMessage && (
          <div
            style={{
              color: "green",
              textAlign: "center",
              margin: "0px 0px 18px 0px",
              fontSize: "22px",
            }}
          >
            {successMessage}
          </div>
        )}
        <Typography sx={{ textAlign: "left" }}>
          “Congratulations!" Your email address has been successfully verified,
          and your account is now fully activated. Thank you for taking the time
          to complete this step.
        </Typography>
        <Typography sx={{ textAlign: "left", marginTop: "15px" }}>
          Now that your email address is verified, you can{" "}
          <RouterLink
            to="/signin"
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            click here to log in
          </RouterLink>{" "}
          and enjoy the full benefits of our services.
        </Typography>
        <Typography sx={{ textAlign: "left", marginTop: "15px" }}>
          If you have any questions or encounter any issues, please don't
          hesitate to reach out to our support team at{" "}
          <a href="mailto:guest@investek.in" style={styles.emailLink}>
            guest@investek.in
          </a>
          .”
        </Typography>

       
      </Box>

      <Footer /></span>)}

      
    </>
  );
};

export default Emailpage;

const styles = {
  formbox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "35px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "350px",
    width: "400px",
    backgroundColor: "light gray",
  },
  formboxres: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "35px",
    background: "#FFFFFF",
    borderRadius: "8px",
    textAlign: "center",
    height: "350px",
    width: "290px",
    backgroundColor: "light gray",
  },
};
